(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["features-5610-a"] && !Shopify.designMode) return;
  try {
    
  // No interactive behavior; static informational section.
  // Hook for future analytics:
  document.querySelectorAll('.why-innova').forEach(function (el) {
    el.dataset.ready = 'true';
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-5610"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* ─── Scroll-triggered reveal ─── */
    const initReveal = () => {
      // Standalone reveal children (e.g. .hero5610a__actions outside a .hero5610a--reveal parent)
      const standaloneChildren = document.querySelectorAll(
        '.hero5610a--reveal-child:not(.hero5610a--reveal .hero5610a--reveal-child)'
      );

      // Parent containers whose children animate together
      const revealParents = document.querySelectorAll('.hero5610a--reveal');

      if (!('IntersectionObserver' in window)) {
        // Fallback: just show everything immediately
        document.querySelectorAll('.hero5610a--reveal-child').forEach(el => {
          el.style.opacity = '1';
          el.style.transform = 'none';
        });
        return;
      }

      const observerOpts = { threshold: 0.15 };

      // Observe parent groups
      const parentObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            parentObserver.unobserve(entry.target);
          }
        });
      }, observerOpts);

      revealParents.forEach(el => parentObserver.observe(el));

      // Observe standalone children (e.g. actions row at desktop breakpoint)
      const childObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            childObserver.unobserve(entry.target);
          }
        });
      }, observerOpts);

      standaloneChildren.forEach(el => childObserver.observe(el));
    };

    /* ─── Modal ─── */
    const initModal = () => {
      document.querySelectorAll('[data-hero5610a-modal]').forEach(function (modal) {
        var section = modal.previousElementSibling;
        if (!section || !section.classList.contains('hero5610a')) {
          section = document.querySelector('.hero5610a');
        }
        var video = modal.querySelector('[data-hero5610a-video]');
        var openBtns = section ? section.querySelectorAll('[data-hero5610a-open]') : [];
        var closeEls = modal.querySelectorAll('[data-hero5610a-close]');
        
        function open() {
          modal.hidden = false;
          document.body.style.overflow = 'hidden';
          if (video) { try { video.currentTime = 0; video.play(); } catch (e) {} }
        }
        function close() {
          modal.hidden = true;
          document.body.style.overflow = '';
          if (video) { video.pause(); }
        }
        openBtns.forEach(function (b) { b.addEventListener('click', open); });
        closeEls.forEach(function (c) { c.addEventListener('click', close); });
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && !modal.hidden) close();
        });
      });
    };

    initReveal();
    initModal();

    document.addEventListener('shopify:section:load', function () {
      initReveal();
      initModal();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scotty-video-strip"] && !Shopify.designMode) return;
  try {
    
  (function(){
    document.querySelectorAll('.scotty-strip').forEach(function(section){
      var lightbox = section.querySelector('.scotty-lightbox');
      var frame = lightbox.querySelector('.scotty-lightbox__frame');
      var closeBtn = lightbox.querySelector('.scotty-lightbox__close');

      section.querySelectorAll('.scotty-card').forEach(function(card){
        card.addEventListener('click', function(){
          var url = card.getAttribute('data-video-url');
          var type = card.getAttribute('data-video-type');
          if(!url) return;

          // Clear previous content
          frame.innerHTML = '';

          if(type === 'native') {
            var video = document.createElement('video');
            video.src = url;
            video.controls = true;
            video.autoplay = true;
            frame.appendChild(video);
          } else {
            var iframe = document.createElement('iframe');
            iframe.src = url;
            iframe.allow = "autoplay; encrypted-media; picture-in-picture";
            iframe.allowFullscreen = true;
            frame.appendChild(iframe);
          }

          lightbox.hidden = false;
          document.body.style.overflow = 'hidden';
        });
      });

      function close(){
        lightbox.hidden = true;
        frame.innerHTML = ''; // Stop video playback entirely
        document.body.style.overflow = '';
      }
      closeBtn.addEventListener('click', close);
      lightbox.addEventListener('click', function(e){ if(e.target === lightbox) close(); });
      document.addEventListener('keydown', function(e){ if(e.key === 'Escape' && !lightbox.hidden) close(); });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
